<template>
  <div class="total-container">
    <mtd-row  type="flex" class="row-bg" justify="space-around">
      <mtd-col :xs="24" :sm="24" :md="16" :lg="12" :xl="9">
        <div class="tips-card">
          <mtd-card class="card-box">
            <div class="tips-card-title">安全提示</div>
            <div class="tooltip-text" v-if="show_text">
              <template>
                <mtd-loading message="正在加载数据，请稍后..."/>
              </template>
            </div>
            <div v-if="!show_text">
              <mtd-announcement title="根据公司安全规定，您的访问受到限制"
                                type="warning"
                                show-icon style="margin-top: 24px" />
              <div class="tips-content">
                {{ iamText }}
              </div>
            </div>
            <div class="btn-area">
              <mtd-button class="btn-demo-item" type="warning" :loading="submit_loading" @click="open_complaint()">申 诉</mtd-button>
            </div>
          </mtd-card>
        </div>
      </mtd-col>
    </mtd-row>
  </div>
</template>

<script>

    import {mapActions} from 'vuex'

    export default {
      name: "intercept",
      computed: {
        login_user() {
          return this.$store.getters.get_login_user;
        },
      },
      data() {
        return {
          show_text: false,
          submit_loading: false,
          contentId: '',
          iamText: '',
          iamUrl: '',
          query_param: {
            misId: '',
            system: '',
            command: '',
            polComSettingId: ''
          },
        }
      },
      mounted: function () {
        this.contentId = this.$route.query.contentId;
        setTimeout(() => {
          this.query_param.misId = this.login_user.mis_id || this.$route.query.misId;
          console.log('misId: ' + this.query_param.misId);
          this.query_param.system = this.$route.query.system;
          this.query_param.command = this.$route.query.command;
          this.query_param.polComSettingId = this.$route.query.settingId;

          this.getIamPageInfoLogout();
        }, 500)
      },
      methods: {
        ...mapActions([
          'api_get_iam_page_info_logout'
        ]),
        async getIamPageInfoLogout() {
          this.show_text = true;
          this.submit_loading = true;
          this.api_get_iam_page_info_logout(this.query_param).then(res => {
            console.log(this.show_text)
            let data = res.data;
            if (res.data) {
              this.iamText = data.iamText;
              this.iamUrl = data.iamUrl;
            }
          }).finally(() => {
            this.show_text = false;
            this.submit_loading = false;
          });
        },
        open_complaint() {
          let url = this.iamUrl;
          if (url) {
            if (this.iamUrl.indexOf('?') > 0) {
              url += '&';
            } else {
              url += '?';
            }
            if (this.query_param.misId) {
              url += 'misId=' + this.query_param.misId;
            }
            if (this.contentId) {
              url += 'contentId' + this.contentId;
            }
            window.open(url);
          } else {
            this.$mtd.message.error('无法确定申诉配置');
          }
        }
      }
    }
</script>

<style scoped>
  @import "../../styles/main-container.css";
  @import "../../styles/public.css";

  .tips-card {
    width: 100%;
    margin-top: 200px;
  }
  .tips-card-title {
    text-align: center;
    font-size: 28px;
    font-weight: 800;
  }
  .tips-content {
    text-align: center;
    font-size: 18px;
    margin-top: 24px;
  }
  .btn-area {
    text-align: center;
    margin-top: 32px;
  }
</style>
